import AppLayout from '../AppLayout'
import basicRouter from './basicRouter';
import webWxRouter from './webWxRouter';
import messageRouter from './messageRouter';
import payRouter from './payRouter';
import membershipRouter from './membershipRouter';
import faPiaoCenterRouter from './faPiaoCenterRouter';
import mfRouter from './mfRouter';

//system
import Home from '../components/system/Welcome'
import Configs from '../components/basic/configs/Configs';
import ConfigNodes from '../components/basic/configs/ConfigNodes';
import Logger from '../components/system/logger/Logger';
import CronTasks from '../components/system/cronTasks/CronTasks';
import CronTasksEx from '../components/system/cronTasks/CronTasksEx';
import DbBackups from '../components/system/db/DbBackups';

import FilesServer from '../components/filesSystem/FilesServer';
import FilesService from '../components/filesSystem/FilesService';
import FilesGroup from "../components/filesSystem/FilesGroup";
import Files from "../components/filesSystem/Files";

import WebGlobalData from '../components/system/WebGlobalData';

//development
import { RouteObject } from "react-router-dom"

import DevelopProjects from '../components/development/DevelopProjects';
import DevelopApi from '../components/development/DevelopApi';
import DevelopDatabase from '../components/development/DevelopDatabase';
import DevelopTable from '../components/development/DevelopTable';
import Login from '../components/basic/login/Login';

//t
import Passage from '../components/t/Passage';

const routers: RouteObject[] = [
  {
    path: "/",
    element: <AppLayout></AppLayout>,
    children: [
      {
        element: <Home />,
        index: true
      },
      {
        path: "/configs",
        element: <Configs />,
      },
      {
        path: "/configNodes",
        element: <ConfigNodes />,
      },
      {
        path: "/logger",
        element: <Logger />,
      },
      {
        path: "/filesServer",
        element: <FilesServer />,
      },
      {
        path: "/filesService",
        element: <FilesService />,
      },
      {
        path: "/filesGroup",
        element: <FilesGroup />,
      },
      {
        path: "/files",
        element: <Files />,
      },
      {
        path: "/globalData",
        element: <WebGlobalData />,
      },
      {
        path: "/cronTasks",
        element: <CronTasks />,
      },
      {
        path: "/cronTasksEx",
        element: <CronTasksEx />,
      },
      {
        path: "/dbBackups",
        element: <DbBackups />,
      },

      //development
      {
        path: "/developProjects",
        element: <DevelopProjects />,
      },
      {
        path: "/developApi",
        element: <DevelopApi />,
      },
      {
        path: "/developDatabase",
        element: <DevelopDatabase />,
      },
      {
        path: "/developTable",
        element: <DevelopTable />,
      },
      //t
      {
        path: "/passage",
        element: <Passage />,
      },
      {
        path: '*',
        element: <div>找不到页面/页面不存在</div>
      }

    ]
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '*',
    element: <div>找不到页面/页面不存在</div>
  }


]
let indexRouters = routers.map((item: any, index: number) => {
  if (item.children) {
    return {
      ...item, children: item.children.concat(basicRouter)
        .concat(webWxRouter)
        .concat(messageRouter)
        .concat(payRouter)
        .concat(membershipRouter)
        .concat(faPiaoCenterRouter)
        .concat(mfRouter)
    }
  } else {
    return { ...item }
  }
})


export default indexRouters;